import { ref } from 'vue'

export function useFullscreen(onResize) {
  function toggleFullScreen(el) {
    if (!el) return
    if (!document.fullscreenElement) {
      el.requestFullscreen?.() ||
        el.webkitRequestFullScreen?.() ||
        el.mozRequestFullScreen?.() ||
        el.msRequestFullscreen?.()
    } else {
      document.exitFullscreen?.() ||
        document.mozCancelFullScreen?.() ||
        document.webkitExitFullscreen?.() ||
        document.msExitFullscreen?.()
    }
    onResize?.()
  }
  return { toggleFullScreen }
}

export function useChartResize(resizeTargets) {
  const observer = ref(null)

  function resizeAll() {
    resizeTargets().forEach((target) => target?.resize?.())
  }

  function observe(el) {
    if (!el) return
    observer.value = new ResizeObserver(resizeAll)
    observer.value.observe(el)
  }

  function disconnect() {
    observer.value?.disconnect()
  }

  return { observe, disconnect, resizeAll }
}
